


import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import Graph from "react-graph-vis";

const options = {
  layout: {
    hierarchical: false
  },
  edges: {
    color: "#000000"
  }
};

function randomColor() {
  const red = Math.floor(Math.random() * 256).toString(16).padStart(2, '0');
  const green = Math.floor(Math.random() * 256).toString(16).padStart(2, '0');
  const blue = Math.floor(Math.random() * 256).toString(16).padStart(2, '0');
  return `#${red}${green}${blue}`;
}

const NxTopology = () => {
  const graph = {
    nodes: [
      { id: 1, label: "Procedure", color: "#cb8782", shape: "box"  },
      { id: 2, label: "Patient", color: "#f0c69d", shape: "box" },
      { id: 3, label: "Condition", color: "#f4dd9b", shape: "box" },
      { id: 4, label: "Observation", color: "#9cc49a", shape: "box" },
      { id: 5, label: "Encounter", color: "#9ab0c4",  shape: "icon",
      icon: {
        face: "'FontAwesome'",
        code: "\uf007",
        size: 50,
        color: "#aa00ff",
      }, }
    ],
    edges: [
      {
        from: 1,
        to: 2,
        smooth: {
          enabled: true
        },
        color: "red"
      },
      {
        from: 2,
        to: 1,
        smooth: {
          enabled: true
        },
        color: "red"
      },
      {
        from: 2,
        to: 1,
        smooth: {
          enabled: false
        },
        color: "green"
      },
      {
        from: 3,
        to: 2,
        smooth: {
          enabled: true
        },
        color: "#EAC215"
      },
      {
        from: 4,
        to: 2,
        smooth: {
          enabled: true
        },
        color: "#5e765c"
      },
      {
        from: 5,
        to: 3,
        smooth: {
          enabled: true
        },
        color: "#254460"
      },
      {
        from: 3,
        to: 4,
        // smooth: {
        //   enabled: true
        // },
        color: "#EAC215"
      },
      {
        from: 4,
        to: 3,
        // smooth: {
        //   enabled: true
        // },
        color: "#EAC215"
      }
    ]
  };

  const options = {
    nodes: {
      chosen: {
        borderColor: "EAC215"
      }
    },
    interaction: {
      dragNodes: true,
      dragView: true,
      hover: true
  },
    layout: {
      hierarchical: {
        enabled: true,
        levelSeparation: 150,
        nodeSpacing: 200,
        treeSpacing: 200,
        blockShifting: true,
        edgeMinimization: true,
        parentCentralization: true,
        direction: "LR", // UD, DU, LR, RL
        sortMethod: "hubsize", // hubsize, directed
        shakeTowards: "leaves" // roots, leaves
      }
    },
    edges: {
      color: "#000000"
    },
    height: "700px",
    physics: {
      // enabled: true,
      // maxVelocity: 50,
      // minVelocity: 0.1,
      // solver: "barnesHut",
      stabilization: {
        enabled: true,
        iterations: 1000,
        updateInterval: 100,
        onlyDynamicEdges: false,
        fit: true
      }
    }
  };

  const events = {
    select: function (event) {
      
      var { nodes, edges } = event;
      console.log(nodes);
      console.log(edges);
    }
  };

  useEffect(() => {}, []);
  return (
    <Graph
      graph={graph}
      options={options}
      events={events}
      getNetwork={(network) => {
        //  if you want access to vis.js network api you can set the state in a parent component using this property
      }}
    />
  );
};



export default NxTopology